import { defineMessages } from 'react-intl'
import { HOME_INSURANCE_RISKS } from './homeInsurance'

export const MARKETS = defineMessages({
  seller: {
    id: 'Markets.seller',
    defaultMessage: 'Seller‘s market',
  },
  buyer: {
    id: 'Markets.buyer',
    defaultMessage: 'Buyer‘s market',
  },
})

export const AIRDNA_QUALITY = defineMessages({
  basic: {
    id: 'AirDna.rentalQuality.basic',
    defaultMessage: 'basic',
  },
  nice: {
    id: 'AirDna.rentalQuality.nice',
    defaultMessage: 'nice',
  },
  fancy: {
    id: 'AirDna.rentalQuality.fancy',
    defaultMessage: 'fancy',
  },
})

export const AIRDNA_FREQUENCY = defineMessages({
  seldom: {
    id: 'AirDna.rentalFrequency.seldom',
    defaultMessage: 'seldom',
  },
  often: {
    id: 'AirDna.rentalFrequency.often',
    defaultMessage: 'often',
  },
})

export const AIRDNA_TOOLIPS = defineMessages({
  description: {
    id: 'AirDna.chartTooltipHeader.monthlyAverage',
    defaultMessage: '{month} Avg.',
  },
  revenue: {
    id: 'AirDna.chartTooltip.revenue',
    defaultMessage: '${amount}' // eslint-disable-line
  },
  occupancy: {
    id: 'AirDna.chartTooltip.occupancy',
    defaultMessage: '{amount} Nights',
  },
  adr: {
    id: 'AirDna.chartTooltip.nightlyRate',
    defaultMessage: '${amount}/night' // eslint-disable-line
  },
})

export const FORM_PLACEHOLDERS = defineMessages({
  firstName: {
    id: 'Form.placeholder.firstName',
    defaultMessage: 'First Name',
  },
  lastName: {
    id: 'Form.placeholder.lastName',
    defaultMessage: 'Last Name',
  },
  phone: {
    id: 'Form.placeholder.phone',
    defaultMessage: 'Phone',
  },
  email: {
    id: 'Form.placeholder.email',
    defaultMessage: 'Email Address',
  },
  address: {
    id: 'Form.placeholder.address',
    defaultMessage: 'Address',
  },
  zip: {
    id: 'Form.placeholder.zipCode',
    defaultMessage: 'Zip code',
  },
})

export const BUTTONS = defineMessages({
  back: {
    id: 'Buttons.navigation.back',
    defaultMessage: 'Back',
  },
  change: {
    id: 'Buttons.actions.change',
    defaultMessage: 'Change',
  },
})

export const QUESTIONS = defineMessages({
  prequalTopic: {
    id: 'Questions.prequal.topic',
    defaultMessage: 'Pre-Qual Request',
  },
  getPrequal: {
    id: 'Affordability.noPrequal.question',
    defaultMessage: 'Can I get a Pre-Qual?',
  },
  getListingDetailsPrequalified: {
    id: 'ListingDetails.prequal.question',
    defaultMessage: 'Can I get pre-qualified?',
  },
  howIsTheNeighborhood: {
    id: 'ListingDetails.neigborhood.question',
    defaultMessage: 'How is the neighborhood?',
  },
  renewPrequal: {
    id: 'Affordability.hasPrequal.question',
    defaultMessage: 'Can you renew my Pre-Qual?',
  },
  emailUpdate: {
    id: 'EmailUpdates.panel.question',
    defaultMessage: 'Can you update my email?',
  },
  timelineShrink: {
    id: 'Questions.timeline.shrink',
    defaultMessage: 'How do I shrink these timelines?',
  },
  affordabilityTopic: {
    id: 'Questions.affordability.topic',
    defaultMessage: 'Interest Rates & Affordability',
    description: 'Topic in email to REA',
  },
  lockInRates: {
    id: 'Questions.affordability.lockInRates',
    defaultMessage: 'How do I lock in before rates rise?',
  },
  downPayment: {
    id: 'Questions.affordability.downPayment',
    defaultMessage: 'What down payment do I really need?',
  },
  marketActivityTopic: {
    id: 'Questions.marketActivity.topic',
    defaultMessage: 'Markets & Buying Timelines',
    description: 'Topic in email to REA',
  },
  getStarted: {
    id: 'Questions.marketActivity.getStarted',
    defaultMessage: 'How do I get started?',
  },
  closeFaster: {
    id: 'Questions.marketActivity.closeFaster',
    defaultMessage: 'How can I close faster?',
  },
  zipCodeDetailTopic: {
    id: 'Questions.zipCodeDetail.topic',
    defaultMessage: 'What should I know about {zipcode}?',
  },
  listings: {
    id: 'Questions.listings',
    defaultMessage: 'How can I see homes in {zipcode}?',
  },
  listingsTopic: {
    id: 'Questions.listingsTopic',
    defaultMessage: 'Listings',
  },
  placeholder: {
    id: 'Questions.placeholder',
    defaultMessage: 'Ask a question…',
  },
  sendSuccess: {
    id: 'Questions.send.success',
    defaultMessage: 'Message sent!',
  },
  sendFailure: {
    id: 'Questions.send.failure',
    defaultMessage: 'Message failed to send',
  },
  favoriteMarketsTitle: {
    id: 'Questions.favoriteMarkets.title',
    defaultMessage: 'Have any questions?',
  },
  favoriteMarketsTopic: {
    id: 'Questions.favoriteMarkets.topic',
    defaultMessage: 'Exploring Markets',
  },
  whatMarkets: {
    id: 'Questions.favoriteMarkets.whatMarkets',
    defaultMessage: 'What areas should I be looking at?',
  },
  fasterHomeSearch: {
    id: 'Questions.favoriteMarkets.fasterHomeSearch',
    defaultMessage: 'Is there new construction I should know about?',
  },
  homebuyingTopic: {
    id: 'Questions.homebuying.topic',
    defaultMessage: 'Homebuying',
  },
  homebuyingPlaceholder: {
    id: 'Questions.homebuying.placeholder',
    defaultMessage: 'Questions?',
  },
  mortgageInsuranceTopic: {
    id: 'Questions.mortgageInsurance.topic',
    defaultMessage: 'Mortgage Insurance',
  },
  mortgageInsuranceFooter: {
    id: 'Questions.mortgageInsurance.dropPMIFaster',
    defaultMessage: 'How would I drop mortgage insurance faster?',
  },
  mortgageInsuranceFooterV2: {
    id: 'Questions.mortgageInsurance.howCanIRemovePmi',
    defaultMessage: 'How can I remove my mortgage insurance?',
  },
  mortgageInsuranceEstimatedPanelFooter: {
    id: 'Questions.mortgageInsurance.estimatedPMI.footer',
    defaultMessage: 'Do you know if I have PMI?',
  },
  reverseMortgagesTitle: {
    id: 'Questions.reverseMortgages.title',
    defaultMessage: 'Want to learn more?',
  },
  reverseMortgagesTopic: {
    id: 'Questions.reverseMortgages.topic',
    defaultMessage: 'Reverse Mortgages',
  },
  eligibleHomeTypes: {
    id: 'Questions.reverseMortgages.eligibleHomeTypes',
    defaultMessage: 'What types of homes are eligible?',
  },
  interestCardTopic: {
    id: 'Questions.interest.topic',
    defaultMessage: 'Principal Payments',
  },
  interestCardRefinance: {
    id: 'Questions.interest.vsRefinance',
    defaultMessage: 'What are the trade-offs versus refinancing?',
  },
  interestCardLargePayment: {
    id: 'Questions.interest.singleLargePayment',
    defaultMessage: 'What if I made a single large payment?',
  },
  refinanceTopic: {
    id: 'Questions.refinance.topic',
    defaultMessage: 'Refinancing',
  },
  refinanceRate: {
    id: 'Questions.refinance.rateQuestion',
    defaultMessage: 'What would my rate be?',
  },
  refinanceCost: {
    id: 'Questions.refinance.costQuestion',
    defaultMessage: 'How much does it cost?',
  },
  refinanceFees: {
    id: 'Questions.refinance.feeQuestion',
    defaultMessage: 'Can you explain the fees?',
  },
  refinanceCashout: {
    id: 'Questions.refinance.cashoutQuestion',
    defaultMessage: 'What are my cashout options?',
  },
  refinanceRecoup: {
    id: 'Questions.refinance.recoupQuestion',
    defaultMessage: 'How long until I recoup closing costs?',
  },
  refiDetailsSend: {
    id: 'Questions.refinance.refiDetailsSend',
    defaultMessage: 'Have {contactFirstName} run your {label}',
  },
  refiDetailsCheck: {
    id: 'Questions.refinance.refiDetailsCheck',
    defaultMessage: 'Check your {label} options',
  },
  refiDetailRate: {
    id: 'Questions.refinance.refiDetailRate',
    defaultMessage: 'Get your rate',
  },
  homeAppreciationTopic: {
    id: 'Questions.shouldYouSell.appreciation.topic',
    defaultMessage: "their home's appreciation",
  },
  mortgageCoachRequest: {
    id: 'MortgageCoach.requestTCA',
    defaultMessage: 'Get detailed breakdown',
  },
  insuranceTopic: {
    id: 'Questions.insurance.topic',
    defaultMessage: 'insurance agents',
  },
  insuranceRecommendation: {
    id: 'Questions.insurance.recommendation',
    defaultMessage: 'Do you know any insurance agents?',
  },
  cashPositionTopic: {
    id: 'Questions.shouldTheySell.recommendation.topic',
    defaultMessage: 'their cash position',
  },
  goodCashPosition: {
    id: 'ShouldYouSell.cashPosition.good.body.question',
    defaultMessage: 'Can you pre-qualify me?',
  },
  badCashPosition: {
    id: 'ShouldYouSell.cashPosition.bad.body.question',
    defaultMessage: 'How far out am I?',
  },
  whatSellForTopic: {
    id: 'ShouldYouSell.WhatSellFor.question.topic',
    defaultMessage: 'what they could sell for',
  },
  whatSellFor: {
    id: 'ShouldYouSell.WhatSellFor.question.placeholder',
    defaultMessage:
      'Do you know any buyers who would be interested in my home?',
  },
  shouldYouSellFooterTopic: {
    id: 'ShouldYouSell.questions.panel.footer.topic',
    defaultMessage: 'if they should sell',
  },
  maximizeListingPrice: {
    id: 'ShouldYouSell.questions.maximize.listing.price',
    defaultMessage: 'How can I prepare my home to maximize my listing price?',
  },
  marketForBuying: {
    id: 'ShouldYouSell.questions.buying.market',
    defaultMessage: "How's the market for buying?",
  },
  shouldYouSellMarketTopic: {
    id: 'Homeowner.marketSpotlight.questions.sell.topic',
    defaultMessage: 'their market temperature',
  },
  shouldSellNow: {
    id: 'Homeowner.marketSpotlight.questions.sell',
    defaultMessage: 'Should I sell now?',
  },
  marketSpotlightTopic: {
    id: 'Homeowner.marketSpotlight.questions.topic',
    defaultMessage: 'their Market',
  },
  marketNeighborhood: {
    id: 'Homeowner.marketSpotlight.questions.nextSteps',
    defaultMessage: 'How’s my neighborhood doing?',
  },
  airDnaTopic: {
    id: 'Questions.airdna.topic',
    defaultMessage: 'Short Term Rentals',
  },
  videoEmailTopic: {
    id: 'Questions.videoEmail.topic',
    defaultMessage: 'Your Video Email Message',
  },
  listingDetailsLoTopic: {
    id: 'Questions.listingDetails.lo.topic',
    defaultMessage: 'getting pre-qualified for this listing!',
  },
  listingDetailsReaTopic: {
    id: 'Questions.listingDetails.rea.topic',
    defaultMessage: "how's the neighborhood?",
  },
  homeValueEstimateFooterTopic: {
    id: 'Questions.homeValueEstimate.FooterTopic',
    defaultMessage: 'the value of their home',
  },
  understandWhatMyHomeIsWorth: {
    id: 'Questions.homeValueEstimate.understandWhatMyHomeIsWorth',
    defaultMessage:
      'Can you help me understand what my home is probably worth?',
  },
  homeValueEstimateMarketForBuyingNewHome: {
    id: 'Questions.homeValueEstimate.MarketForBuyingNewHome',
    defaultMessage: "How's the market for buying a new home?",
  },
})

export const SHARE = defineMessages({
  inviteLinkCopied: {
    id: 'Homeowner.share.inviteLinkCopied',
    defaultMessage: 'Share link copied to clipboard',
  },
  success: {
    id: 'Homeowner.share.success',
    defaultMessage: 'Invite sent!',
  },
})

export const SUBSCRIPTIONS = defineMessages({
  notificationSubscribed: {
    id: 'Subscriptions.subscribed',
    defaultMessage: 'You have been subscribed to the monthly report',
  },
  notificationSubscribedHomeownerEmails: {
    id: 'Subscriptions.subscribedHomeownerEmails',
    defaultMessage: 'You have been subscribed to home updates',
  },
  notificationSubscribedHomeMarket: {
    id: 'Subscriptions.subscribedHomeMarket',
    defaultMessage: 'You have been subscribed to home market updates',
  },
  notificationSubscribedListings: {
    id: 'Subscriptions.subscribedListings',
    defaultMessage: 'You have been subscribed to listing updates',
  },
  notificationSubscribedToCustomer: {
    id: 'Subscriptions.subscribedToCustomer',
    defaultMessage: 'You have been successfully subscribed!',
  },
  notificationUnsubscribed: {
    id: 'Subscriptions.unsubscribed',
    defaultMessage: 'You have been unsubscribed from the monthly report',
  },
  notificationUnsubscribedHomeownerEmails: {
    id: 'Subscriptions.unsubscribedHomeownerEmails',
    defaultMessage: 'You have been unsubscribed from home updates',
  },
  notificationUnsubscribedHomeMarket: {
    id: 'Subscriptions.unsubscribedHomeMarket',
    defaultMessage: 'You have been unsubscribed from home market updates',
  },
  notificationUnsubscribedListings: {
    id: 'Subscriptions.unsubscribedListings',
    defaultMessage: 'You have been unsubscribed from listing updates',
  },
  notificationUnsubscribedFromCustomer: {
    id: 'Subscriptions.unsubscribedFromCustomer',
    defaultMessage: 'You have been successfully unsubscribed!',
  },
  notificationError: {
    id: 'Subscriptions.error',
    defaultMessage: 'There was an error changing your subscription status',
  },
})

export const ZIP_CODE_DETAIL = defineMessages({
  popularity: {
    id: 'ZipCodeDetail.sectionHeader.popularity',
    defaultMessage: 'Temperature',
  },
  houseSize: {
    id: 'ZipCodeDetail.sectionHeader.houseSize',
    defaultMessage: 'House size',
  },
  prices: {
    id: 'ZipCodeDetail.sectionHeader.prices',
    defaultMessage: 'Prices',
  },
  timeline: {
    id: 'ZipCodeDetail.sectionHeader.timeline',
    defaultMessage: 'Buying timeline',
  },
  timelineDuration: {
    id: 'Timeline.prepare.duration',
    defaultMessage: '{daycount} days',
  },
  sqft: {
    id: 'ZipCodeTable.activeFilter.sqft',
    defaultMessage: '{value, number} sqft',
  },
})

export const ZIP_CODE_EXPLORER = defineMessages({
  searchPlaceholder: {
    id: 'ZipCodeExplorer.search.placeholder',
    defaultMessage: 'Search for a city…',
  },
  filterPlaceholder: {
    id: 'ZipCodeExplorer.filter.placeholder',
    defaultMessage: 'Filter by neighborhood…',
  },
})

export const ERRORS = defineMessages({
  defaultHeadline: {
    id: 'ErrorBoundary.default.headline',
    defaultMessage: 'Something went wrong…',
  },
  defaultMessage: {
    id: 'ErrorBoundary.default.message',
    defaultMessage:
      'Our team has been notified. Try reloading the page in a few minutes.',
  },
  communicationError: {
    id: 'ErrorBoundary.communication.message',
    defaultMessage: 'Failed to communicate with server, try again shortly.',
  },
})

export const PREFERENCES = defineMessages({
  saved: {
    id: 'Preferences.notifications.saved',
    defaultMessage: 'Your preferences were saved!',
  },
  errored: {
    id: 'Preferences.notifications.errored',
    defaultMessage:
      'Failed communication with our server, your preferences have not been persisted.',
  },
  duh: {
    id: 'Preferences.notifications.duh',
    defaultMessage: 'Client preferences cannot be updated in preview mode.',
  },
})

export const NO_ACCESS_ERROR = defineMessages({
  defaultMessage: {
    id: 'ErrorBoundary.noAccess.loanBalance.message',
    defaultMessage:
      'Sorry, you can’t update the loan balance on behalf of your client.',
  },
})

export const HOME_DETAIL_UPDATE_ERROR = defineMessages({
  defaultMessage: {
    id: 'ErrorBoundary.valuation.homeUpdate.failure.message',
    defaultMessage:
      'Your new value has been saved in our system, but we couldn’t reflect the updates in your digest. Please try refreshing.',
  },
})

export const REFINANCE = defineMessages({
  savings: {
    id: 'Refinance.savingsDescriptor',
    defaultMessage: 'savings',
  },
  loss: {
    id: 'Refinance.lossDescriptor',
    defaultMessage: 'loss',
  },
  paymentIncrease: {
    id: 'Refinance.paymentIncrease.descriptor',
    defaultMessage: 'up',
  },
  paymentDecrease: {
    id: 'Refinance.paymentDecrease.descriptor',
    defaultMessage: 'down',
  },
})

export const LOAN_BALANCE = defineMessages({
  balanceIncreasedSuccessMessage: {
    id: 'Loan.balance.success.messsage',
    defaultMessage: 'Your balance was successfully updated!',
  },
})

export const HOME_INSURANCE = defineMessages({
  feedbackReceived: {
    id: 'Homeowner.homeInsurance.feedbackReceived',
    defaultMessage: 'Thanks for the feedback!',
  },
})

export const PROMPT_PREQUAL = defineMessages({
  email_link: {
    id: 'PromptPrequal.done.emailName',
    defaultMessage: 'Email {name}',
  },
})

export const SYSTEM_REQUEST = defineMessages({
  mcSuccessTopic: {
    id: 'SystemRequest.mcSuccessTopic',
    defaultMessage: 'Mortgage Coach',
  },
  equitySmartSearchTableCalculationTopic: {
    id: 'SystemRequest.equitySmartSearchTableCalculationTopic',
    defaultMessage: 'Equity Smart Search Calculation',
  },
  avmDifferenceWarningTopic: {
    id: 'SystemRequest.avmDifferenceWarningTopic',
    defaultMessage: 'their home value',
  },
  nonDisclosureWarningTopic: {
    id: 'SystemRequest.nonDisclosureWarningTopic',
    defaultMessage: 'their home value',
  },
  prequalTopic: {
    id: 'SystemRequest.prequalTopic',
    defaultMessage: 'Buyer Prequalification',
  },
  prequalMessage: {
    id: 'SystemRequest.prequalMessage',
    defaultMessage: 'Can you get me prequalified?',
  },
  refiTopic: {
    id: 'SystemRequest.refiTopic',
    defaultMessage: 'Refinancing',
  },
  refiMessage: {
    id: 'SystemRequest.refiMessage',
    defaultMessage: 'Please send my refi options',
  },
  labeledRefiMessage: {
    id: 'SystemRequest.labeledRefiMessage',
    defaultMessage: 'Please send me {label} refi options',
  },
  homeInsuranceTopic: {
    id: 'SystemRequest.homeInsuranceTopic',
    defaultMessage: 'Home Insurance',
  },
  homeInsuranceMessage: {
    id: 'SystemRequest.homeInsuranceMessage',
    defaultMessage: 'Can you help me check my insurance policy?',
  },
  reverseMortgageTopic: {
    id: 'SystemRequest.reverseMortgageTopic',
    defaultMessage: 'Reverse Mortgages',
  },
  reverseMortgageMessage: {
    id: 'SystemRequest.reverseMortgageMessage',
    defaultMessage: 'What are my other options?',
  },
})

export const MARKET_TEMP_HEADERS = defineMessages({
  '0-20': {
    id: 'Explorer.marketTemp.header.0-20',
    defaultMessage: 'Strong Buyer’s Advantage',
  },
  '21-40': {
    id: 'Explorer.marketTemp.header.21-40',
    defaultMessage: 'Buyer’s Advantage',
  },
  '41-60': {
    id: 'Explorer.marketTemp.header.41-60',
    defaultMessage: 'Balanced Market',
  },
  '61-80': {
    id: 'Explorer.marketTemp.header.61-80',
    defaultMessage: 'Seller’s Advantage',
  },
  '81-100': {
    id: 'Explorer.marketTemp.header.81-100',
    defaultMessage: 'Strong Seller’s Advantage',
  },
})

export const MARKET_TEMP_DESCRIPTIONS = defineMessages({
  '0-20': {
    id: 'Explorer.marketTemp.0-20',
    defaultMessage:
      'Little competition and high inventory, meaning you have great negotiating power.',
  },
  '21-40': {
    id: 'Explorer.marketTemp.21-40',
    defaultMessage:
      'Some competition but you’re still likely to get a good deal since inventory is high.',
  },
  '41-60': {
    id: 'Explorer.marketTemp.41-60',
    defaultMessage:
      'Expect to see a nice mix of good inventory with stable home values.',
  },
  '61-80': {
    id: 'Explorer.marketTemp.61-80',
    defaultMessage:
      'Decent competition and steady home value growth could make for a great investment.',
  },
  '81-100': {
    id: 'Explorer.marketTemp.81-100',
    defaultMessage:
      'This means there is some fierce competition and low inventory.',
  },
})

export const HOME_INSURANCE_RISK_MESSAGES = defineMessages({
  [HOME_INSURANCE_RISKS.LOW]: {
    id: 'HomeInsurance.risk.low',
    defaultMessage: 'low',
  },
  [HOME_INSURANCE_RISKS.MID]: {
    id: 'HomeInsurance.risk.moderate',
    defaultMessage: 'moderate',
  },
  [HOME_INSURANCE_RISKS.HIGH]: {
    id: 'HomeInsurance.risk.high',
    defaultMessage: 'high',
  },
})

export const TCA_STATUS = defineMessages({
  success: {
    id: 'MortgageCoachRequestButton.success',
    defaultMessage: 'Successfully created TCA',
  },
  failure: {
    id: 'MortgageCoachRequestButton.failure',
    defaultMessage: 'Failed to create TCA',
  },
})

export const HOME_INSURANCE_CTA = defineMessages({
  snoozeSuccess: {
    id: 'Homeowner.homeInsurance.snoozeSuccess',
    defaultMessage: 'Cool, we’ll remind you next year',
  },
  confirmDetailsSuccess: {
    id: 'Homeowner.homeInsurance.confirmDetailsSuccess',
    defaultMessage: 'Your insurance details are updated',
  },
})

export const OUTREACH_BUTTON = defineMessages({
  success: {
    id: 'success',
    defaultMessage: 'Message sent!',
  },
  failure: {
    id: 'failure',
    defaultMessage: 'Please try again later!',
  },
})
